import { useIsAccountantSupportContext } from "@hooks/useIsAccountantSupportContext";

interface HelpCenterUrls {
    businessOwner: string;
    accountant: string;
}

export const HELP_CENTER_URLS = {
    home: {
        businessOwner: "https://docs.kick.co",
        accountant: "https://docs.kick.co/accountants",
    },
    transactions: {
        businessOwner: "https://docs.kick.co/common-workflows/transactions",
        accountant:
            "https://docs.kick.co/accountants/bookkeeping-workflows/transactions",
    },
    rules: {
        businessOwner: "https://docs.kick.co/common-workflows/rules",
        accountant:
            "https://docs.kick.co/accountants/bookkeeping-workflows/rules",
    },
    locks: {
        businessOwner: "https://docs.kick.co/working-with-your-team/locks",
        accountant: "https://docs.kick.co/accountants/close-workflows/locks",
    },
} satisfies Record<string, HelpCenterUrls>;

export function useHelpCenterUrl(
    helpCenterUrls: HelpCenterUrls = HELP_CENTER_URLS.home,
): string | null {
    const { isAccountant, isReady } = useIsAccountantSupportContext();

    if (!isReady) {
        return null;
    }

    return isAccountant
        ? helpCenterUrls.accountant
        : helpCenterUrls.businessOwner;
}
